import React, { Component } from "react";
import FieldError from "./FieldError";
import {cx} from "../../lib/ClassSet";
import "./TextAreaInputField.scss";

const noOp = () => null;

class TextAreaInputField extends Component {

  render() {
    const {serverError, label, active, input: {value, onChange}, meta: {touched, error}} = this.props;    

    let changeHandler = active ? onChange : noOp;
    let classes = cx({
      "TextAreaInput": true,
      "s-inactive": !active
    });

    if (this.props.table === false) {
      return (
        <div className="TextAreaInputField field">
          <div>{label}</div>
          <textarea className={classes} type="text" value={value} onChange={changeHandler} rows={this.props.rows}/>
          <FieldError serverError={serverError} clientError={error} showClientError={touched && error} />
        </div>
      )
    }

    return (
      <tr className="TextAreaInputField field">
        <th>{label}</th>
        <td>
          <textarea className={classes} type="text" value={value} onChange={changeHandler} rows={this.props.rows}/>
          <FieldError serverError={serverError} clientError={error} showClientError={touched && error} />
        </td>
      </tr>
    )
  }

}

TextAreaInputField.defaultProps = {
  active: true,
  rows: 6,
  table: true
}

export default TextAreaInputField;